/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputTypeDTO
 */
export interface InputTypeDTO {
    /**
     * 
     * @type {number}
     * @memberof InputTypeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InputTypeDTO
     */
    description?: string;
}

export function InputTypeDTOFromJSON(json: any): InputTypeDTO {
    return InputTypeDTOFromJSONTyped(json, false);
}

export function InputTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputTypeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function InputTypeDTOToJSON(value?: InputTypeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
    };
}

